import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { getRealizedBackground } from '@common/utils/discrepancy.util';
import { DisplayDiscrepanciesService } from 'app/singleton-services/display-discrepancies.service';

@Component({
    selector: 'app-discrepancy-value',
    template: `
        <span>
            @if (canSeeRealized && realizedValue !== null && realizedValue !== undefined && realizedValue !== 0) {
                <div
                    class="pill justify-content-end"
                    [ngClass]="getRealizedBackground(realizedValue, plannedValue || 0, canSeeRealized)">
                    @if (displayDiscrepancies) {
                        <div>
                            {{ realizedValue - (plannedValue || 0) | number: numberFormat : 'de' }}
                        </div>
                    }
                    @if (!displayDiscrepancies) {
                        <div>
                            {{ realizedValue | number: numberFormat : 'de' }} /
                            {{ plannedValue || 0 | number: numberFormat : 'de' }}
                        </div>
                    }
                </div>
            }
            @if (!canSeeRealized || realizedValue === null || realizedValue === undefined || realizedValue === 0) {
                <div class="text-right">
                    {{ plannedValue | number: numberFormat : 'de' }}
                </div>
            }
        </span>
        @if (canSeeRealized && showIcon) {
            <span
                class="w-auto"
                role="button"
                kendoTooltip
                [title]="iconTooltip"
                (click)="onIconClick && onIconClick()">
                <i class="fa fa-file"></i>
            </span>
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DiscrepancyValueComponent implements OnInit {
    @Input() realizedValue: number;
    @Input() plannedValue: number;
    @Input() canSeeRealized: boolean;
    @Input() decimalPlaces: number = 0;
    @Input() showIcon: boolean = false;
    @Input() iconTooltip: string = '';
    @Input() onIconClick: () => void;
    numberFormat: string;

    // Expose utility function for template use
    getRealizedBackground = getRealizedBackground;

    constructor(private displayDiscrepanciesService: DisplayDiscrepanciesService) {}

    ngOnInit() {
        this.numberFormat = `1.${this.decimalPlaces}-${this.decimalPlaces}`;
    }

    get displayDiscrepancies(): boolean {
        return this.displayDiscrepanciesService.displayDiscrepancies;
    }
}
